import api from "@/api/api-v2-config";

export async function getLeaveRequestListAxios() {    
    return await api.get("hrms/leaverequest?PageNumber=1&PageSize=10000");
}

// export async function deleteLeaveRequestAxios(id) {    
//     return await api.delete("distributions/gpsdevices?GPSDeviceId=" + id);
// }

export async function postLeaveRequestAxios(leaverequest) {    
    return await api.post("hrms/leaverequest", leaverequest);
}

export async function putLeaveRequestApprovalAxios(leaverequest) {    
    return await api.put("hrms/leaverequest/approval", leaverequest);
}

export async function putLeaveRequestAxios(leaverequest) {    
    return await api.put("hrms/leaverequest", leaverequest);
}

// export async function getLeaveRequestByIDAxios(id) {    
//     return await api.get("distributions/gpsdevices/" + id);
// }

export async function getLeaveRequestEmployeeAxios() {    
    return await api.get("hrms/leaverequest/employee");
}

export async function getLeaveRequestSubordinatesAxios() {    
    return await api.get("hrms/leaverequest/subordinates");
}